export function ExamIcon({ className = "" }) {
  return (
    <svg
      width="32"
      height="31"
      viewBox="0 0 32 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M20.1 9.16667H26.7L20.1 2.75V9.16667ZM11.7 1H21.3L28.5 8V22C28.5 22.6188 28.2471 23.2123 27.7971 23.6499C27.347 24.0875 26.7365 24.3333 26.1 24.3333H11.7C11.0635 24.3333 10.453 24.0875 10.0029 23.6499C9.55286 23.2123 9.3 22.6188 9.3 22V3.33333C9.3 2.71449 9.55286 2.121 10.0029 1.68342C10.453 1.24583 11.0635 1 11.7 1M6.9 5.66667V26.6667H26.1V29H6.9C6.26348 29 5.65303 28.7542 5.20294 28.3166C4.75286 27.879 4.5 27.2855 4.5 26.6667V5.66667H6.9Z"
        fill="currentColor"
      />
    </svg>
  );
}
